module.exports = __webpack_public_path__ + "img/scroll-arrow-to-down.75451806.svg";